import React from 'react';

import CreationButton from 'components/shadow_grid/shadows/creation/button';

export default function ShadowsHeader() {
  return (
    <div className="d-flex justify-content-between align-items-end mb-3">
      <h6>Grids</h6>
      <CreationButton />
    </div>
  );
}
